import React from "react"

export default () => {
  const year = String(new Date().getFullYear());
  const yearRange = "2020" === year ? year : ("2020 - " + year);

  return (
    <footer>
      © {yearRange}, Yondemy
    </footer>
  );
}
